import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { PaginatorInput } from '@shared/components/paginator/models/paginator-input.model';
import {
  DraftListing,
  ProcedureListing,
  ProceduresListingFilters,
  ProceduresListingTab,
} from '@core/domain/model/procedures/procedures-listing.model';

export const proceduresListingActions = createActionGroup({
  source: 'ProceduresListing',
  events: {
    setFilters: props<{ filters: ProceduresListingFilters }>(),
    setType: props<{ procedureType: ProceduresListingTab }>(),
    setPagination: props<{ pagination: PaginatorInput }>(),
    setData: props<{ data: DraftListing[] | ProcedureListing[] }>(),
    setError: props<{ error: string }>(),
    deleteDraft: props<{ draftId: number }>(),
    updateList: emptyProps(),
  },
});
